<template lang="pug">
    gmh-account-edit(ref="accountEdit")
</template>

<script>
export default {
    name: "settings-account-management",
    mounted() {
        if (this.$route.params && this.$route.params.hash) {
            this.$refs.accountEdit.scrollToEl(this.$route.params.hash)
        }
    }
}
</script>
